__turbopack_context__.v({
  "ChartContainer": "KVOxGW_ChartContainer",
  "ChartContainerHeatmap": "KVOxGW_ChartContainerHeatmap",
  "ChartContainerTimeline": "KVOxGW_ChartContainerTimeline",
  "ChartHeader": "KVOxGW_ChartHeader",
  "ChartTitle": "KVOxGW_ChartTitle",
  "ChartTitle--Large": "KVOxGW_ChartTitle--Large",
  "DynamicPropertyContainer": "KVOxGW_DynamicPropertyContainer",
  "Error": "KVOxGW_Error",
  "ErrorWrapper": "KVOxGW_ErrorWrapper",
  "LoaderContainer": "KVOxGW_LoaderContainer",
  "Root": "KVOxGW_Root",
  "TreeMapTotal": "KVOxGW_TreeMapTotal",
  "skeleton-loading": "KVOxGW_skeleton-loading",
});
